import { render, staticRenderFns } from "./VideoCourseItem.vue?vue&type=template&id=9099bf94&scoped=true&"
import script from "./VideoCourseItem.vue?vue&type=script&lang=js&"
export * from "./VideoCourseItem.vue?vue&type=script&lang=js&"
import style0 from "./VideoCourseItem.vue?vue&type=style&index=0&id=9099bf94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9099bf94",
  null
  
)

export default component.exports